module.exports = __webpack_public_path__ + "img/icon_kefu.fe18ef63.gif";